import $ from 'jquery'

const mediaQuery_mobile = window.matchMedia('(max-width: 767px)')
$(document).ready(function () {
    $('.kv').length, setTimeout(function () {
        $('html').removeClass('-loading'), $('html').addClass('-loaded-kv')
    }, 200)
}), $(window).on('load', function () {
    showFooterMenu()
})
// var currentWidth = window.innerWidth
window.addEventListener('resize', function () {
    // showFooterMenu(), currentWidth != window.innerWidth && (currentWidth = window.innerWidth)
})
const footer_class = '.gb-common-2019_footer'

function showFooterMenu() {
    $(footer_class + '__funcTitle').on('ontouchstart' in window ? 'touchstart' : 'click', function () {
        if (mediaQuery_mobile.matches) {
            const e = $(footer_class + '__funcSec')
            const t = '-opened'
            const n = $(this)
            const o = n.parent()
            const a = n.parents(footer_class)
            if (o.hasClass(t)) {
                o.removeClass(t)
                a.removeAttr('style')
                $('html').removeClass('-f-menu-open')
            } else {
                e.removeClass(t)
                o.addClass(t)
                if (n.parent(footer_class + '__funcSec').hasClass('-global')) {
                    a.css('min-height', (n.parent(footer_class + '__funcSec')?.find(footer_class + '__funcContent')?.height() || 0) + 75 + 50)
                } else {
                    a.removeAttr('style')
                    $('html').addClass('-f-menu-open')
                }
            }
        }
    })
    $(footer_class + '__toggleBtn').on('ontouchstart' in window ? 'touchstart' : 'click', function () {
        if (!mediaQuery_mobile.matches) {
            const e = footer_class
            const t = footer_class + '__content'
            const n = '-closed'
            const o = 'easeOutQuint'
            const a = $(this).parents(e)
            const s = a.find(t)
            if (a.hasClass(n)) {
                a.removeClass(n)
                s.stop().animate({ opacity: 0, height: 'toggle' }, { duration: 850, easing: o })
                $(footer_class + '__toggleBtnText').text($(footer_class + '__toggleBtn').attr('data-open') || '')
            } else {
                a.addClass(n)
                s.stop().animate({ opacity: 1, height: 'toggle' }, { duration: 850, easing: o })
                $('html,body').stop().animate({ scrollTop: $(document).height() }, 850, o)
                $(footer_class + '__toggleBtnText').text($(footer_class + '__toggleBtn').attr('data-close') || '')
            }
        }
    })
}

function closeFooterMenu() {
    $(footer_class + '__funcSec').hasClass('-opened') && ($(footer_class + '__funcSec').removeClass('-opened'), $('html').removeClass('-f-menu-open'))
}

function footer_elastic(e: JQuery<HTMLElement>) {
    var t = '-opened', n = 'easeOutQuint', o = e.parent('.elastic__item'), a = o.find('.elastic__detail')
    o.hasClass(t) ? (o.removeClass(t), a.stop().animate({ opacity: 0, height: 'toggle' }, { duration: 350, easing: n })) : (o.addClass(t), a.stop().animate({ opacity: 1, height: 'toggle' }, { duration: 350, easing: n }))
}

$(document).keydown((e: JQuery.KeyDownEvent) => {
    27 == e.keyCode && closeFooterMenu()
})

$(function () {
    $('.elastic__item').length && $('.elastic__header.gb-common-2019_footer__menuCatText').each(function () {
        // @ts-ignore
        $(this).click(function () {
            // @ts-ignore
            const e = $(this)
            e.parents('.elastic').hasClass('-only-sp') ? mediaQuery_mobile.matches && footer_elastic(e) : footer_elastic(e)
        })
    })
})
